import { TravelSheetService } from './../../services/travel-sheet.service';
import { Component, OnInit } from '@angular/core';
import { TravelSheetModel } from '../travel-sheet/travel-sheet.model';
import { CommonMessageService } from '../../services/common-message.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-my-pending-travel-sheet-approvals',
  templateUrl: './my-pending-travel-sheet-approvals.component.html',
  styleUrls: ['./my-pending-travel-sheet-approvals.component.css']
})
export class MyPendingTravelSheetApprovalsComponent implements OnInit {
  pendingTravelSheetList: Array<TravelSheetModel>;
  travelSheetModel: TravelSheetModel;
  userId;
  userFName;
  userLName;
  // userRole;
  constructor(private travelSheetService: TravelSheetService,
    private commonMessageService: CommonMessageService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    // this.userRole=localStorage.getItem('userRole');
    // if(this.userRole=='Account Executive'){
    //   this.getAllSubmittedTravelSheetList()
    // }else{
    // this.getAllPendingTravelSheetList();
    // }
    this.getAllPendingTravelSheetList();
  }

  getAllPendingTravelSheetList() {
    this.userId = localStorage.getItem('id');
    console.log('userId', this.userId);
    this.travelSheetService.getPendingTravelSheetDetails(this.userId).subscribe((resp: any) => {
      this.pendingTravelSheetList = resp;
      console.log('travel sheet', this.pendingTravelSheetList);
    });
  }

  // getAllSubmittedTravelSheetList(){
  //   this.travelSheetService.getAllSubmittedTravelSheetDetails().subscribe((resp:any)=>{
  //     console.log('submitted travel sheet',resp);
  //     this.pendingTravelSheetList=resp;
  //   });
  // }

  approvedTravelSheet(travelsheet) {
    this.resendReasonText = undefined;
    this.travelSheetService.getApprovedResendTravelSheetDetails(travelsheet.id, 'Approved', this.resendReasonText).subscribe((resp: any) => {
      this.commonMessageService.swalAlertWithIcon('','Approved Successfully!','success');
      this.getAllPendingTravelSheetList();
    });
  }


  resendTravelSheet() {
    console.log('resone of text', this.resendReasonText);
    this.resendReasonText = this.resendReasonText.replace(/\s\s+/g, ' ');

    if (this.resendReasonText == undefined || this.resendReasonText == '' || this.resendReasonText == ' ') {
      this.commonMessageService.swalAlertWithoutIcon('','Please enter reason.');
      return;
    }
    this.travelSheetService.getApprovedResendTravelSheetDetails(this.resendTrvelSheetDetails.id, 'Resent', this.resendReasonText).subscribe((resp: any) => {
      this.commonMessageService.swalAlertWithIcon('','Resend Successfully!','success');
      this.closeModal();
      this.getAllPendingTravelSheetList();
    });
  }

  resendReasonText;
  resendTrvelSheetDetails;
  openResendModal(openResendModal, travelSheet) {
    this.modalService.open(openResendModal, { ariaLabelledBy: 'modal-basic-title', size: 's', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
    this.resendTrvelSheetDetails = travelSheet;
  }

  openModal(modalContent) {
    this.modalService.open(modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  fareDocumentsList;
  openDocumentModal(content, fareDocuments) {
    this.fareDocumentsList = fareDocuments;
    this.openModal(content);
  }

  ViewTravelSheet(travelsheet, modalContent) {
    console.log('travel sheet details', travelsheet);
    this.travelSheetModel = { ...travelsheet };
    this.openModal(modalContent);
  }

  closeModal() {
    this.resendReasonText = "";
    this.modalService.dismissAll();
  }
}
